import { createApp } from 'vue'
import Main from './Main.vue'
import '@/main.less'
createApp(Main).mount('#app')
